// extracted by mini-css-extract-plugin
module.exports = {"textAreaInput":"TextArea_textAreaInput__ds5Bx","disabledInput":"TextArea_disabledInput__2c_71"};